import { Table } from "semantic-ui-react";
import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { useAuth, userActiveView } from "../../utils/Auth";
import PositionEditAction from "./PositionEditAction";
import { LinkPosition } from "../Routes";

export const PositionTableRow = ({ position, reload, active }) => {
  let { url } = useRouteMatch();
  const { user } = useAuth();
  return (
    <Table.Row>
      <Table.Cell>
        <LinkPosition position={position}>{position.name}</LinkPosition>
      </Table.Cell>
      <Table.Cell>{position.seniority_level?.level ?? "-"}</Table.Cell>
      <Table.Cell>{position.category}</Table.Cell>
      {active && <Table.Cell>{position.employee_count}</Table.Cell>}
      {userActiveView(user) && active && (
        <Table.Cell textAlign={"center"}>
          <PositionEditAction position={position} reload={reload} />
        </Table.Cell>
      )}
    </Table.Row>
  );
};
